import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { getHighestUser } from 'utils/misc'
import { USER_ROLE_ID_MAP } from 'utils/constants'
import StudiesList from '../components/StudiesList'
import { studiesAction } from '../modules/Studies'
import { actions as studyAction } from '../../routes/CreateStudy/modules/CreateStudy'
import { retrieveStudyPaginationSettings, clearStudyPaginationSettings } from 'utils/studyConfigUtils'
import { removeStudyDurationForTimeline } from 'utils/studyDurationForTimeline'

const mapState = state => {
  const { loading, study, studiesPage, user, searchTerm } = state
  const currentUserRoleId = getHighestUser({ user, getRoleId: true })
  const studyPaginationSettings = retrieveStudyPaginationSettings(user?.id)
  if (!studyPaginationSettings) {
    clearStudyPaginationSettings()
  }
  const roleIdArrWithNoCreateStudyAccess = [
    USER_ROLE_ID_MAP.enroller,
    USER_ROLE_ID_MAP.siteCoordinator,
    USER_ROLE_ID_MAP.caseManager,
    USER_ROLE_ID_MAP.clinicalCoordinator,
    USER_ROLE_ID_MAP.siteUserManagementAdmin,
    USER_ROLE_ID_MAP.siteCoordinatorUAT,
    USER_ROLE_ID_MAP.clinicalCoordinatorUAT,
    USER_ROLE_ID_MAP.siteCoordinatorDEV,
    USER_ROLE_ID_MAP.clinicalCoordinatorDEV,
  ]
  return {
    isListLoading: !!loading.studiesList,
    study: study.currentStudy,
    studyVersionList: study.studyVersionList,
    studiesPage,
    allowCreateStudy:
      getHighestUser({ user }).includes('wu') && !roleIdArrWithNoCreateStudyAccess.includes(currentUserRoleId),
    user,
    searchTerm,
    studyPaginationSettings,
  }
}

export default connect(mapState, { ...studyAction, ...studiesAction })(props => {
  useEffect(() => {
    // Clear study duration from session when user returns to studies list
    removeStudyDurationForTimeline()
  }, [])

  return <StudiesList {...props} />
})
